export default "https://cdn-static.gokick.com/assets/5a032fdfc840f3d1fce44ec205c52ed2ca8e0677/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";